import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalAccountListFilterCountsDocument = gql`
  query SalesPortalAccountListFilterCounts(
    $businessOrganizationUUID: uuid!
    $filters: SalesPortalAccountListFilters
  ) {
    getSalesPortalAccountListFilterCounts(
      business_organization_id: $businessOrganizationUUID
      filters: $filters
    ) {
      group_counts {
        count
        group_id
        name
      }
      status_counts {
        count
        status
      }
    }
  }
`;
export function useSalesPortalAccountListFilterCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalAccountListFilterCountsQuery,
    Types.SalesPortalAccountListFilterCountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalAccountListFilterCountsQuery,
    Types.SalesPortalAccountListFilterCountsQueryVariables
  >(SalesPortalAccountListFilterCountsDocument, options);
}
export function useSalesPortalAccountListFilterCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalAccountListFilterCountsQuery,
    Types.SalesPortalAccountListFilterCountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalAccountListFilterCountsQuery,
    Types.SalesPortalAccountListFilterCountsQueryVariables
  >(SalesPortalAccountListFilterCountsDocument, options);
}
export type SalesPortalAccountListFilterCountsQueryHookResult = ReturnType<
  typeof useSalesPortalAccountListFilterCountsQuery
>;
export type SalesPortalAccountListFilterCountsLazyQueryHookResult = ReturnType<
  typeof useSalesPortalAccountListFilterCountsLazyQuery
>;
export type SalesPortalAccountListFilterCountsQueryResult = Apollo.QueryResult<
  Types.SalesPortalAccountListFilterCountsQuery,
  Types.SalesPortalAccountListFilterCountsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalAccountListFilterCountsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalAccountListFilterCountsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalAccountListFilterCountsQuery,
    Types.SalesPortalAccountListFilterCountsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalAccountListFilterCountsQuery,
    Types.SalesPortalAccountListFilterCountsQueryVariables
  >(SalesPortalAccountListFilterCountsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalAccountListFilterCountsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalAccountListFilterCountsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalAccountListFilterCountsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalAccountListFilterCountsQuery,
    Types.SalesPortalAccountListFilterCountsQueryVariables
  >(SalesPortalAccountListFilterCountsDocument, lazyOptions);
}
